import { Component, OnInit, ViewChild } from '@angular/core';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoTableColumn } from '@po-ui/ng-components';
import { defaultTransferenciaPedidoParaPedidoFiltro, RomaneioItem, RomaneioItemLista, TransferenciaPedidoParaPedidoFiltro, TransferenciaPedidoParaPedidoLista } from '../../romaneio/interface/romaneio';
import { ExcelService } from 'src/app/service/excel-service';
import { Zpr } from 'src/app/interface/zpr';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { PedidoService } from 'src/app/faturamento/service/pedido.service';

@Component({
  selector: 'app-pedido-para-pedido',
  templateUrl: './pedido-para-pedido.component.html',
  styleUrls: ['./pedido-para-pedido.component.css']
})
export class PedidoParaPedidoComponent implements OnInit {

  CZ02PEDIDO: string = '';
  CC5NUM: string = '';
  CC5PEDEXP: string = '';
  tabelaPrincipalItens: Array<RomaneioItem> = [];
  itemsSelecionados: RomaneioItemLista = {items: []}
  itensTransferidos: TransferenciaPedidoParaPedidoLista;
  filtro: TransferenciaPedidoParaPedidoFiltro;
  motivoTransferencia: string = '';
  transfereDoArmazem: boolean;

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  constructor(
    private romaneioService: RomaneioService,
    private pedidoService: PedidoService,
    private router: Router,
    private excelService: ExcelService,
    private poNotificationService: PoNotificationService,
    public zprService: ZprLookupService,
  ) {
    this.itensTransferidos = {items:[]};
    this.transfereDoArmazem = false;

    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;

    this.zprService.grupo = 'MOTTRANSF';

    this.filtro = defaultTransferenciaPedidoParaPedidoFiltro();
  }

  @ViewChild('transferirPedidoModal', { static: true }) transferirPedidoModal!: PoModalComponent;

  ngOnInit(): void {
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CB1COD'     , label: 'Cód. Produto'     , width: '15%'},
    {property: 'CB1DESC'    , label: 'Desc. Produto'    , width: '55%'},
    {property: 'CZ02PEDIDO' , label: 'Pedido'           , width: '15%'},
    {property: 'CEE7PEDIDO' , label: 'P.O'              , width: '15%'},
    {property: 'CZ02INFORM' , label: 'T ou E'           , width: '10%', type: 'label',
      labels: [
        { value: 'T', color: 'color-01',  label: 'Toco'     },
        { value: 'E', color: 'color-05',  label: 'Esqui'    },
      ]
    },
    {property: 'CZ01ETIQ'   , label: 'Lote'             , width: '10%'},
    {property: 'NZ01QUANT'  , label: 'Quantidade'       , width: '10%'},
    {property: 'CZ02STATUS' , label: 'Local'            , width: '10%', type: 'label' ,
      labels: [
        { value: 'P', color: 'color-03', label: 'Armazém'},
        { value: 'O', color: 'color-05', label: 'Estoque'},
      ]
    },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Expedição', action: this.goTo.bind(this) },
      { label: 'Pedido para Pedido' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  consultaPedido(): void {
    this.romaneioService.consultaPedidoTransferencia(this.filtro).subscribe((res) => {
      this.tabelaPrincipalItens = res.items;
      this.transfereDoArmazem = false;
      this.tabelaPrincipalItens.map((item) => {
        if (item.CZ02STATUS == 'P') {
          this.transfereDoArmazem = true;
        }
      })
    });
  }

  transfereEstoque(): void {
    if (this.transfereDoArmazem) {
      this.transferirPedidoModal.open();
    } else {
      this.romaneioService.transferenciaArmazemPedido(this.CZ02PEDIDO, this.motivoTransferencia).subscribe((res) => {
        this.CZ02PEDIDO = '';
        this.tabelaPrincipalItens = [];
        this.motivoTransferencia = '';
        this.poNotificationService.success("Pedido transferido com sucesso!");
      });
    }
  }

  transferePedido(): void {
    this.itemsSelecionados.items = this.tabelaPrincipalItens.filter((item) => item.$selected);

    if (this.itemsSelecionados.items.length > 0 && (this.CC5NUM != '' || this.CC5PEDEXP != '')) {
      this.romaneioService.transferenciaPedidoItens(this.filtro.CZ02PEDIDO, this.CC5NUM != '' ? this.CC5NUM : this.CC5PEDEXP, this.CC5NUM != '' ? '1': '2', this.itemsSelecionados).subscribe((res) => {
        this.itensTransferidos = res;

        const lista_excel = this.itensTransferidos.items.map( (item) => {
          return{
            'Romaneio Origem'   :  item.CZ02CODORI,
            'Lote'              :  item.CZ02LOTE,
            'Romaneio Destino'  :  item.CZ02CODORI,
          }
        });
        this.excelService.exportAsExcelFile(lista_excel, `LotesTransferidos_${this.CZ02PEDIDO}_para_${this.CC5NUM}`);
        this.poNotificationService.success({
          message: 'Alteração de Pedido para Pedido realizada com sucesso!',
          duration: 5000
        });
        this.consultaPedido();
      });
    } else {
      this.poNotificationService.warning({
        message: 'Por favor, informe os pedidos origem e destino.',
        duration: 5000
      })
    }
  }

  public readonly transferirPedidoAction: PoModalAction = {
    action: () => {
      if (this.CZ02PEDIDO != '') {
        if (this.motivoTransferencia != '') {
          this.romaneioService.transferenciaArmazemPedido(this.CZ02PEDIDO, this.motivoTransferencia).subscribe((res) => {
            this.transferirPedidoModal.close();
            this.CZ02PEDIDO = '';
            this.tabelaPrincipalItens = [];
            this.motivoTransferencia = '';
            this.poNotificationService.success("Pedido transferido com sucesso!");
          });
        } else {
          this.poNotificationService.warning({
            message: 'Por favor, informe um motivo para a transferência',
            duration: 5000
          });
        }
      } else {
        this.poNotificationService.warning({
          message: 'Por favor, informe o pedido origem.',
          duration: 5000
        });
      }
    },
    label: 'Transferir',
  };

  selecaoPedido(n: Number): void {
    if (n == 1) {
      this.filtro.CEE7PEDIDO = "";
      this.pedidoService.getCodigoPedido(this.filtro).subscribe((ret) => {
        this.filtro.CEE7PEDIDO = ret.CC5PEDEXP.trim();
      });
    } else if (n == 2) {
      this.filtro.CZ02PEDIDO = "";
      this.pedidoService.getCodigoPedido(this.filtro).subscribe((ret) => {
        this.filtro.CZ02PEDIDO = ret.CC5NUM.trim();
      });
    } else if (n == 3) {
      this.CC5PEDEXP = "";
      this.pedidoService.getCodigoPedido({...defaultTransferenciaPedidoParaPedidoFiltro(), CZ02PEDIDO: this.CC5NUM}).subscribe((ret) => {
        this.CC5PEDEXP = ret.CC5PEDEXP.trim();
      });
    } else if (n == 4) {
      this.CC5NUM = "";
      this.pedidoService.getCodigoPedido({...defaultTransferenciaPedidoParaPedidoFiltro(), CEE7PEDIDO: this.CC5PEDEXP}).subscribe((ret) => {
        this.CC5NUM = ret.CC5NUM.trim();
      });
    }
  }

}
